
import {gql, Apollo} from 'apollo-angular';
import {of as observableOf, Observable} from 'rxjs';

import {tap, share, mergeMap, map, first} from 'rxjs/operators';
import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "./utils.service";
import {UiStateService} from "./ui-state.service";


import {AuthenticationService} from "../../authentication/authentication.service";
import {ProgressService} from "./progress.service";
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {FacebookFundraiserService} from "./facebook-fundraiser.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import {FacebookFundraiserDeletionDialogComponent} from "../components/dialogs/facebook-fundraiser-deletion-dialog/facebook-fundraiser-deletion-dialog.component";
import {ToastrService} from "ngx-toastr";
import * as _ from "lodash";
import {EditGoalDialogComponent} from '../components/edit-goal-dialog/edit-goal-dialog.component';
import {FacebookDialogComponent} from '../../fundraising/facebook-dialog/facebook-dialog.component';
import { GraphqlService } from '../graphql/graphql.service';
import { eventRelatedGql } from '../graphql/queries/event-related.gql';
import { constituentEventsGql } from '../graphql/queries/constituent-events.gql';
import { addressBookGql } from '../graphql/queries/address-book.gql';
import { constituentImagesGql } from '../graphql/queries/constituent-images.gql';
import { personalImageGql } from '../graphql/queries/personal-image.gql';
import { donationAmountsGql } from '../graphql/queries/donation-amounts.gql';
import { emailTemplatesGql } from '../graphql/queries/email-templates.gql';
import { toolboxContentGql } from '../graphql/queries/toolbox-content.gql';
import { personalGql } from '../graphql/queries/personal.gql';
import { emailsGql } from '../graphql/queries/emails.gql';
import { phonesGql } from '../graphql/queries/phones.gql';
import { addressesGql } from '../graphql/queries/addresses.gql';
import { emergencyContactsGql } from '../graphql/queries/emergency-contacts.gql';
import { insuranceDetailsGql } from '../graphql/queries/insurance-details.gql';
import { donationTablesGql } from '../graphql/queries/donations-table.gql';
import { reloadTeamsGql } from '../graphql/queries/reload-teams.gql';
import { HybridToolsService } from './hybrid-tools.service';
import moment from 'moment';

@Injectable()
export class EventService {
    public events;
    public pastEvents = [];
    public allEvents = null;
    public selectedEvent;
    public selectedEventKey;
    public onEventInit: EventEmitter<any> = new EventEmitter();
    public onEventChange: EventEmitter<any> = new EventEmitter();
    public onGqlReload: EventEmitter<any> = new EventEmitter();

    //TODO: The 'name' values below don't seem to be referenced, but we'll currently keep them for clarity.
    public campaigns = {
        'lls': {
            id: 'lls',
            name: 'Leukemia & Lymphoma Society'
        },
        'program-ltn': {
            id: 'ltn',
            name: 'Light the Night'
        },
        'program-tnt': {
            id: 'tnt',
            name: 'Team in Training'
        },
        'program-regatta': {
            id: 'regatta',
            name: 'Leukemia Cup Regatta'
        },
        'program-s2': {
            id: 's2',
            name: 'Hero Squad'
        },
        'program-mwoy': {
            id: 'mwoy',
            name: 'Man & Woman of the Year.'
        },
        'program-voy': {
            id: 'voy',
            name: 'Visionaries of the Year.'
        },
        'program-soy': {
            id: 'soy',
            name: 'Students of the Year.'
        },
        'program-svoy': {
            id: 'svoy',
            name: 'Student Visionaries of the Year.'
        },
        'program-se': {
            id: 'se',
            name: 'Special Event Campaign Event'
        },
        'program-dd': {
            id: 'dd',
            name: 'Donor Dev Campaign Event'
        },
        'program-radiothon': {
            id: 'radiothon',
            name: 'Radiothon Campaign Event'
        }
    };
    public currentCampaign = this.campaigns['lls'];

    // we need this for resolver to wait
    public eventRelatedStuffObservable: Observable<any>;

    constructor(private http: HttpClient,
                private utilsService: UtilsService,
                private uiStateService: UiStateService,
                private apollo: Apollo,
                private authService: AuthenticationService,
                private progressService: ProgressService,
                private router: Router,
                private facebookFundraiserService: FacebookFundraiserService,
                private modalService: NgbModal,
                private ToastrService: ToastrService,
                private graphqlService: GraphqlService,
                private hybridToolsService: HybridToolsService) {
    }

    getAddresses(forceReload = false) {
        return this.graphqlService.query(
            addressesGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].individualConstituent.constituentAddresses = parsedData.Participant[0].individualConstituent.constituentAddresses;
            this.onGqlReload.emit();
            return data;
        }),first());
    }

    getConstituentAddressBook(forceReload = false) {
        return this.graphqlService.query(
            addressBookGql,
            { individualConstituentId: this.authService.user.constituentID },
            forceReload
        );
    }

    getConstituentEvents(route: ActivatedRouteSnapshot, forceReload = false) {
        return this.graphqlService.query(
            constituentEventsGql,
            { individualConstituentId: this.authService.user.constituentID },
            forceReload
        ).pipe(map(data => {
            let events = this.parseConstituentEvents(route, data);
            this.events = this.filterEvents(events, false);
            this.pastEvents = this.filterEvents(events, true);

            return this.events;
        }),mergeMap(events => {
            var allEvents = this.getAllEvents();
            if (allEvents.length === 0) {
                return observableOf({});
            }
            // No event selected? We need to select an event to load with. First, go with the obvious default:
            // the first event in the list.
            var defaultEvent = null;

            if (allEvents.length > 0) {
                defaultEvent = allEvents[0];
            }

            // Alright next, let's see if the user logged in with a campaign in mind (?ProgramGroup=xyz in the URL).
            // If they did, look for the most recent event for that campaign.
            if (this.currentCampaign != null) {
                for (let i = 0; i < allEvents.length; i++) {
                    if (allEvents[i].cssClass == "program-" + this.currentCampaign.id) {
                        defaultEvent = allEvents[i];
                        break;
                    }
                }
                this.setEventInternal(defaultEvent, true);
            } else {
                // Load the same event from last time we used the app, if there is one.
                var lastEvent = this.getLastEvent(allEvents);
                if (lastEvent != null) {
                    this.setEventInternal(lastEvent, true);
                } else {
                    this.setEventInternal(defaultEvent, true);
                }
            }

            return this.eventRelatedStuffObservable;
        }),first());
    }

    getConstituentImages(forceReload = false) {
        return this.graphqlService.query(
            constituentImagesGql,
            { individualConstituentId: this.authService.user.constituentID },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].individualConstituent.constituentImageLibraries = parsedData.IndividualConstituent[0].constituentImageLibraries;
            this.onGqlReload.emit();
            return data;
        }),first());
    }

    getDonationAmounts(fundraiserId, forceReload = false) {
        return this.graphqlService.query(
            donationAmountsGql,
            { fundraiserId: fundraiserId },
            forceReload
        );
    }

    getDonationsTable(forceReload = false) {
        return this.graphqlService.query(
            donationTablesGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        );
    }

    getEmails(forceReload = false) {
        return this.graphqlService.query(
            emailsGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].individualConstituent.constituentEmails = parsedData.Participant[0].individualConstituent.constituentEmails;
            this.onGqlReload.emit();
            return data;
        }), first());
    }

    getEmailTemplates(adoptedEventId, forceReload = false) {
        return this.graphqlService.query(
            emailTemplatesGql,
            { adoptedEventId: adoptedEventId },
            forceReload
        );
    }

    getEmergencyContacts(forceReload = false) {
        return this.graphqlService.query(
            emergencyContactsGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].emergencyContacts = parsedData.Participant[0].emergencyContacts;
            this.onGqlReload.emit();
            return data;
        }), first());
    }

    getInsuranceDetails(forceReload = false) {
        return this.graphqlService.query(
            insuranceDetailsGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].individualConstituent.allergies = parsedData.Participant[0].individualConstituent.allergies;
            this.selectedEvent.gql.Participant[0].individualConstituent.insuranceCompany = parsedData.Participant[0].individualConstituent.insuranceCompany;
            this.selectedEvent.gql.Participant[0].individualConstituent.currentMedications = parsedData.Participant[0].individualConstituent.currentMedications;
            this.selectedEvent.gql.Participant[0].individualConstituent.currentMedicalConditions = parsedData.Participant[0].individualConstituent.currentMedicalConditions;
            this.onGqlReload.emit();
            return data;
        }), first());
    }

    getPersonal(forceReload = false) {
        return this.graphqlService.query(
            personalGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            _.merge(this.selectedEvent.gql.Participant[0].individualConstituent, parsedData.Participant[0].individualConstituent);
            this.onGqlReload.emit();
            return data;
        }));
    }

    getPersonalImage(forceReload = false) {
        return this.graphqlService.query(
            personalImageGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            _.merge(this.selectedEvent.gql.Participant[0].individualConstituent, parsedData.Participant[0].individualConstituent);
            if (this.selectedEvent.gql.Participant[0].team) {
                this.selectedEvent.gql.Participant[0].team.teamMembers = this.getTeamMembers(parsedData.Participant[0].team);
            }
            this.onGqlReload.emit();
            return data;
        }));
    }

    getPhones(forceReload = false) {
        return this.graphqlService.query(
            phonesGql,
            { participantId: this.selectedEvent.participantId },
            forceReload
        ).pipe(map(data => {
            let parsedData = JSON.parse(JSON.stringify(data));
            this.selectedEvent.gql.Participant[0].individualConstituent.constituentPhones = parsedData.Participant[0].individualConstituent.constituentPhones;
            this.onGqlReload.emit();
            return data;
        }), first());
    }

    getToolboxContent(adoptedEventId, forceReload = false) {
        return this.graphqlService.query(
            toolboxContentGql,
            { adoptedEventId: adoptedEventId },
            forceReload
        );
    }

    getAllEvents() {
        if (this.allEvents != null) return this.allEvents;
        this.allEvents = [];
        for (let i = 0; i < this.events.length; i++) this.allEvents.push(this.events[i]);
        for (let i = 0; i < this.pastEvents.length; i++) this.allEvents.push(this.pastEvents[i]);
        return this.allEvents;
    }

    numberOfEvents() {
        if (this.events) {
            return this.events.length + this.pastEvents.length;
        }
    }

    setEvent(event: any) {
        this.setEventInternal(event);
        this.eventRelatedStuffObservable.subscribe(x => {
            this.progressService.stopProgress(false);
        });
    }

    filterEvents(events, pastEventsFlag) {
        return events
            .filter(event => event.isPastEvent === pastEventsFlag)
            .sort((a, b) => {
                return a.eventDate > b.eventDate ? -1 : 1;
            });
    }

    private parseConstituentEvents(route: ActivatedRouteSnapshot, rawParticipants) {
        let programsData = route.parent.data['common']['Program'];

        let processedEvents = [];
        var participants = rawParticipants.IndividualConstituent[0].fundraisingParticipantItems;
        participants.forEach(participant => {

            let programData = programsData.find(o => {
                return ((o.name === participant.programName) && (o.programGroup.name === participant.programGroupName));
            });

            let cssProgramName = '';

            if (programData.programGroup.name === 'S&Y') {
                cssProgramName = 's2';
            } else if (programData.programGroup.name === 'MWOY') {
                cssProgramName = programData.name.toLowerCase();

                //In FY23 mwoy events will become voy events
                if (participant.fiscalYear > 2022) {
                    if (programData.name.toLowerCase() === 'mwoy') {
                        cssProgramName = 'voy';
                    } else if (programData.name.toLowerCase() === 'soy') {
                        cssProgramName = 'svoy';
                    }
                }
            } else {
                cssProgramName = programData.programGroup.name.toLowerCase();
            }
            let formattedEventDat = participant.eventDate + ' ' + participant.eventTime + '+0000';
            processedEvents.push({
                value: participant.eventId.toString(),
                label: participant.eventName,
                cssClass: 'program-' + cssProgramName,
                programGroupDescription: programData.programGroup.description,
                programGroupName: programData.programGroup.name,
                programDescription: programData.description,
                date: moment(formattedEventDat).parseZone().format('MM/DD/YYYY'),
                time: moment(formattedEventDat).parseZone().format('h:mm a'),
                isPastEvent: participant.pastFundraiser,
                eventDate: participant.date,
                participantId: participant.participantId,
                timezone: participant.timezone
            });
        });

        return processedEvents;
    }

    public setCampaignById(campaignId) {
        // Set the campaign for the UI
        if (campaignId in this.campaigns) {
            this.currentCampaign = this.campaigns[campaignId];
         } else {
             this.currentCampaign = null;
        }
        this.uiStateService.setCampaign(this.currentCampaign);
    }

    private getLastEvent(allEvents:any) {
        var lastEvent = localStorage.getItem('org.lls.lastevent');
        if (lastEvent == null) return null;

        if (allEvents != null) {
            for (var i = 0; i < allEvents.length; i++) {
                if (allEvents[i].participantId == lastEvent) return allEvents[i];
            }
        }
        return null;
    }

    private setEventInternal(event: any, isFirst: boolean = false) {
        this.progressService.startProgress(false);
        this.selectedEvent = event;
        this.selectedEventKey = this.selectedEvent.participantId;
        localStorage.setItem("org.lls.lastevent", this.selectedEventKey);

        this.setCampaignById(this.selectedEvent.cssClass);

        // load secondary data once event is set
        this.eventRelatedStuffObservable = this.getLoadEventRelatedGql(
            this.selectedEvent.participantId
        ).pipe(share());

        let onLoadFinish = (response) => {
            this.updateFunds(response);

            this.processTeams();


            if (!this.selectedEvent.isPastEvent && this.selectedEvent.gql.Participant[0].fundraiser &&
                this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles &&
                this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles.length > 0) {
                var facebookFundraiserId = this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles[0].facebookFundraiserId;
                let facebookFundraiserPageDeletionStatusObs = this.facebookFundraiserService.facebookFundraiserPageDeleted(facebookFundraiserId);
                if (facebookFundraiserPageDeletionStatusObs) {
                    facebookFundraiserPageDeletionStatusObs.subscribe(res => {
                        if ('DELETED_FB_FUNDRAISER' === res['deletionStatus']) {
                            const facebookFundraiserDeletionModal = this.modalService.open(FacebookFundraiserDeletionDialogComponent, {backdrop: 'static'});
                            facebookFundraiserDeletionModal.componentInstance.facebookFundraiserId = facebookFundraiserId;
                            facebookFundraiserDeletionModal.result.then((result) => {
                                this.reloadFacebookFundraiserProfile();
                            }, (reason) => {
                            });
                        }
                    });
                }
            }

            if (this.shouldFacebookDialogBeDisplayed() && this.hybridToolsService.canLinkToFacebook()) {

                //this explicitly forces the user to click the close 'x' or to 'Continue with Facebook' so we can handle updating local storage
                const options: NgbModalOptions = {
                    backdrop: 'static',
                    keyboard: false
                }

                const facebookModal = this.modalService.open(FacebookDialogComponent, options);
                facebookModal.componentInstance.participantId = this.selectedEvent.participantId;
            }

        };

        if (isFirst) {
            this.eventRelatedStuffObservable.subscribe(responses => {
                onLoadFinish(responses);
                this.onEventInit.emit(event);
            });
        } else {
            this.eventRelatedStuffObservable.subscribe(responses => {
                onLoadFinish(responses);
                this.onEventChange.emit(event);
            });
        }
    }

    getLoadTeamObservable(teamId, participantId) {
        if (teamId == null) {
            return null;
        }
        if (participantId == null) {
            return null;
        }
        return this.http.get('/api/v1/teams/' + teamId + '/' + participantId + '?page=0&size=1000').pipe(share());
    }

    getLoadEventRelatedGql(participantId) {
        return this.graphqlService.query(
            eventRelatedGql,
            { participantId },
            true
        ).pipe(map(data => {
            this.selectedEvent.gql = JSON.parse(JSON.stringify(data));
            return data;
        }), first());
    }

    updateFunds(response: any) {
        this.selectedEvent.donations = this.parseDonations(response.Participant[0].participantDistributions);
        this.selectedEvent.promises = this.parsePromises(response).list;
    }

    parseDonations(donations: any) {
        if (this.selectedEvent.donations && this.selectedEvent.donations.team) {
            var team = this.selectedEvent.donations.team;
        }
        var list = [];
        var numEntries = donations.length;
        for (var i = 0; i < numEntries; i++) {
            var d = donations[i];
            var donation = {
                amount: this.utilsService.to2dp((parseFloat(d.amount)).toFixed(2)),
                status: (d.status == null ? 'Completed' : this.utilsService.ucFirst(d.status)),
                donationType: d.type,
                paymentMethod: d.paymentMethod,
                fundType: d.fundType,
                source: this.utilsService.ucFirst(d.source),
                donationDate: moment(d.fundDate),
                address: this.utilsService.formatAddress(d),
                fullName: d.donorName,
				donorEmail: d.donorEmail,
				donorDisplayName: d.donorDisplayName,
				donorMessage: d.donorMessage,
				companyMatching: d.companyMatching,
				donorMatchingCompanyName: d.donorMatchingCompanyName,
				honoree: d.honoree,
				donationDescription: d.donationDescription,
				recurringFlag: d.recurringFlag,
                                hasDcf: d.hasDcf,
                raw: d,
                participantDistributionsId: d.participantDistributionsId
            };
            list.push(donation);
        }

        return {
            donationList: list,
            individual: {
                goal: this.selectedEvent.gql.Participant[0].fundraiser.fundraisingGoal,
                percentComplete: Math.max(0,Math.ceil((this.getIndividualTotalRaised() / this.selectedEvent.gql.Participant[0].fundraiser.fundraisingGoal) * 100)),
				totalRaised: this.getIndividualTotalRaised(),
				outstandingPromises: this.getIndividualOutstandingPromises()
            },
            team: team
        };
    }

    parseTeam(response) {
        let team = response;

        if (team != null) {

            this.selectedEvent.donations.team = {
                goal: this.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal,
                percentComplete: Math.max(0, Math.ceil((this.getTeamTotalRaised() / this.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal) * 100)),
				totalRaised: this.getTeamTotalRaised(),
				outstandingPromises: this.getTeamOutstandingPromises()
            };

            // Now avoid 'infinity' if a goal is $0
            if (this.selectedEvent.gql.Participant[0].fundraiser.fundraisingGoal <= 0) {
                this.selectedEvent.donations.individual.percentComplete = 100;
            }
            if (this.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal <= 0) {
                this.selectedEvent.donations.team.percentComplete = 100;
            }
        }
        return team;
    }

    parsePromises(response: any) {
        var promisesData = {
            list : []
        };
        response.Participant[0].participantPromisesMatchingGifts.forEach(p => {
            this.parseGqlPromiseEntry(promisesData, p);
        });
        response.Participant[0].participantPromisesSponsorships.forEach(p => {
            this.parseGqlPromiseEntry(promisesData, p);
        });
        return promisesData;
    }

    processTeams() {
        if (this.selectedEvent.gql.Participant[0].team) {
            this.selectedEvent.gql.Participant[0].team.teamMembers = this.getTeamMembers(this.selectedEvent.gql.Participant[0].team);
            this.getLoadTeamObservable(this.selectedEvent.gql.Participant[0].team.teamId, this.selectedEvent['participantId']).subscribe(response => {
                this.selectedEvent.team = this.parseTeam(response);
            });
        }
    }

    parseGqlPromiseEntry(promisesData, p) {
        const donation = {
			promiseId: p.pdefProgramFundSourceTypeDescription + (p['participantPromisesSponsorshipsId'] || p['participantPromisesMatchingGiftsId']),
            donorName: p.donorName,
            promised: p.promisedAmount,
            received: 0,
            included: p.includedInTotal,
            fundType: p.pdefProgramFundSourceTypeDescription,
            donationDate: p.promisedDate,
            firstName: p.donorFirstName,
            lastName: p.donorLastName,
            distributors: this.parseDonations(p.participantDistributions).donationList
        };

        const distributions = p.participantDistributions;

        if (distributions) {
            distributions.forEach(o => {
                donation.received += +o.amount;
            });

            promisesData.list.push(donation);
        } else {
            promisesData.list.push(donation);
        }
    }

	getIndividualTotalRaised() {
        var totalRaised = this.selectedEvent.gql.Participant[0].fundraiser.donationsReceived + this.getIndividualOutstandingPromises();
        if(this.selectedEvent.gql.Participant[0].fundraiser.facebookDonationsAmount) {
            totalRaised += this.selectedEvent.gql.Participant[0].fundraiser.facebookDonationsAmount;
        }
        return totalRaised;
	}

	getIndividualOutstandingPromises() {
		let result = this.selectedEvent.gql.Participant[0].fundraiser.outstandingMatchingGifts;
		result = result + this.selectedEvent.gql.Participant[0].fundraiser.outstandingSponsorships;
		return result;
	}

	getTeamTotalRaised() {
        const directTeamTotal = this.selectedEvent.gql.Participant[0].team.fundraiser.donationsReceived;
        let teamTotal = directTeamTotal;
        let subTeams = this.selectedEvent.gql.Participant[0].team.subTeams;
        if(!!subTeams) {
            subTeams.forEach(subTeam => {
                teamTotal += subTeam.subTeamTotal;
            });

        }
        return teamTotal + this.getTeamOutstandingPromises();
	}

	getTeamOutstandingPromises() {

		let result = this.selectedEvent.gql.Participant[0].team.fundraiser.outstandingMatchingGifts;
		result = result + this.selectedEvent.gql.Participant[0].team.fundraiser.outstandingSponsorships;

        let subTeams = this.selectedEvent.gql.Participant[0].team.subTeams;
        if(!!subTeams) {
            subTeams.forEach(subTeam => {
                result += subTeam.outstandingMatchingGifts;
                result += subTeam.outstandingSponsorships;
            });

        }

		return result;
	}

	getTeamMembers(team) {
        let allTeamMembers = [];

        team.teamMembers.forEach(function(member) {
            member.grandTotal = this.getGrandTotal(member);
            allTeamMembers.push(member);
        }, this);

        let membersForSubTeams = this.getMembersForSubTeams(team);
        if(!!membersForSubTeams) {
            allTeamMembers.push.apply(allTeamMembers, membersForSubTeams);
        }
        return this.sortTeamMembers(allTeamMembers);
    }

    getMembersForSubTeams(team) {
        let membersForSubTeams = [];
        let subTeams = team.subTeams;
        if(!!subTeams) {
            subTeams.forEach(subTeam => {
                let subTeamMember : any = {};
                subTeamMember.teamMemberId = -subTeam.teamId;
                subTeamMember.totalFunds = subTeam.subTeamTotal;
                subTeamMember.outstandingMatchingGifts = subTeam.outstandingMatchingGifts;
                subTeamMember.outstandingSponsorships = subTeam.outstandingSponsorships;
                subTeamMember.facebookFunds = 0.0;
                subTeamMember.grandTotal = subTeam.subTeamTotal + subTeam.outstandingMatchingGifts + subTeam.outstandingSponsorships;
                subTeamMember.firstName = subTeam.name;
                subTeamMember.lastName = null;
                subTeamMember.email = null;
                subTeamMember.honoree = subTeam.honoree;
                subTeamMember.fullUrl = subTeam.fullUrl;
                subTeamMember.teamCard = true;

                subTeamMember.sportCourse = null;
                subTeamMember.fundraisingGoal = subTeam.fundraisingGoal;
                subTeamMember.officeName = subTeam.officeName;
                subTeamMember.regDate = subTeam.regDate;
                subTeamMember.eventName = subTeam.eventName;
                subTeamMember.eventDate = subTeam.eventDate;
                subTeamMember.recommitted = null;
                subTeamMember.fundraisingCommittment = null;
                membersForSubTeams.push(subTeamMember);
            });

        }
        return membersForSubTeams;
    }

    getGrandTotal(member) {
        var total = 0;
        if(!!member) {
            if(!!member.totalFunds) {
                total += member.totalFunds;
            }
            if(!!member.facebookFunds) {
                total += member.facebookFunds;
            }
            if(!!member.outstandingMatchingGifts) {
                total += member.outstandingMatchingGifts;
            }
            if(!!member.outstandingSponsorships) {
                total += member.outstandingSponsorships;
            }
        }
        return total;
    }

    sortTeamMembers(teamMembers) {
        return teamMembers
            .sort((a, b) => {
                return a.grandTotal > b.grandTotal ? -1 : 1;
            });
    }

    reloadTeams() {
        return this.graphqlService.query(
            reloadTeamsGql,
            { participantId: this.selectedEvent.participantId },
            true
        ).pipe(tap((response) => {
            this.selectedEvent.gql.Participant[0].team = JSON.parse(JSON.stringify(response.Participant[0].team));
            this.processTeams();
        }));
    }

    // Reloads the facebook fundraiser profile section from GraphQL
    reloadFacebookFundraiserProfile() {
        this.progressService.startProgress(false);
        let participantId = this.selectedEvent.participantId;
        var partialQuery = `Participant(participantId: ${participantId}) {
                    participantId
                    individualConstituent {
                      individualConstituentId
                    }
                    event {
                      eventId
                    }
                    fundraiser {
                      activeFacebookFundraiserProfiles {
                        facebookFundraiserId
                      }
                    }
                  }`;
        var query = gql`
                  query EventRelatedQuery {
                    ${partialQuery}
                  }`;

        this.apollo.query<any>({
            fetchPolicy: "network-only",
            query: query
        }).subscribe(res => {
            this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles = res.data.Participant[0].fundraiser.activeFacebookFundraiserProfiles;
            this.progressService.stopProgress(false);
            if (this.router.url.includes('/facebook/fundraiser')) {
                if (this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles.length > 0) {
                    this.router.navigate(['/facebook/fundraiser', this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles[0].facebookFundraiserId]);
                }
            }
        });
    }

    // Reloads the facebook fundraiser profile section from GraphQL
    reloadCountdownRelatedData() { // MTS-3130 - function to call after countdown ends
        this.progressService.startProgress(false);
        const participantId = this.selectedEvent.participantId;
        const partialQuery = `Participant(participantId: ${participantId}) {
                    participantId
                    individualConstituent {
                      individualConstituentId
                    }
                    event {
                      eventId
                    }
                    fundraiser {
                      canAcceptDonations
                    }
                  }`;
        const query = gql`
                  query EventRelatedQuery {
                    ${partialQuery}
                  }`;

        this.apollo.query<any>({
            fetchPolicy: 'network-only',
            query: query
        }).subscribe(res => {
            this.selectedEvent.gql.Participant[0].fundraiser.canAcceptDonations = res.data.Participant[0].fundraiser.canAcceptDonations;
            this.progressService.stopProgress(false);
        });
    }

    public shouldFacebookDialogBeDisplayed() {

        if (!this.selectedEvent.isPastEvent) {
            if (this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles &&
                this.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles.length > 0) {
                // already linked, do nothing
                return false;
            } else {

                const acknowledged = this.facebookFundraiserService.isModalAcknowledged(this.selectedEvent.participantId);
                return this.isFacebookLinkingSupportedForSelectedEvent() && !acknowledged;
            }
        } else {
            return false;
        }
    }

    public isFacebookLinkingSupportedForSelectedEvent() {
        if (!!this.selectedEvent && !!this.selectedEvent.gql && !!this.selectedEvent.gql.Participant[0] && !!this.selectedEvent.gql.Participant[0].fundraiser) {
            // If the page is accepting donations, it should allow Facebook linking
            return this.selectedEvent.gql.Participant[0].fundraiser.canAcceptDonations;
        }
        return false;
    }

    public displayCountdownTimerForSelectedEvent() {
        if (!!this.selectedEvent && !!this.selectedEvent.gql && !!this.selectedEvent.gql.Participant[0] && !!this.selectedEvent.gql.Participant[0].fundraiser) {
            const canAcceptDonations = this.selectedEvent.gql.Participant[0].fundraiser.canAcceptDonations;
            const isPastEvent = this.selectedEvent.isPastEvent;

            // If we cannot donate but it is not a past event, then it must be prior to the kick off; show the timer (mwoy and soy only).
            return (!canAcceptDonations && !isPastEvent && (this.selectedEvent.cssClass === 'program-mwoy' || this.selectedEvent.cssClass === 'program-voy' || this.selectedEvent.cssClass === 'program-soy' || this.selectedEvent.cssClass === 'program-svoy'));
        }
        return false;
    }
}
